import { ColorVariantsDisplayShape } from '../../../app-state-types/reducer-state-types/add-to-cart';

export const colorVariantsShapes = [
  { value: ColorVariantsDisplayShape.circle, label: 'Circle' },
  { value: ColorVariantsDisplayShape.square, label: 'Square' },
];
